var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93533 7.46957L5.43102 0.22957C5.23706 -0.0804297 4.76292 -0.0804297 4.56895 0.22957L0.0646417 7.46957C-0.129324 7.77957 0.107745 8.15957 0.495676 8.15957H3.22197C3.49137 8.15957 3.71766 8.36957 3.71766 8.61957V15.5496C3.71766 15.7996 3.94395 16.0096 4.21335 16.0096H5.77585C6.04525 16.0096 6.27154 15.7996 6.27154 15.5496V8.61957C6.27154 8.36957 6.49783 8.15957 6.76723 8.15957H9.49352C9.87068 8.15957 10.1077 7.77957 9.92456 7.46957H9.93533Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.7707eed84a50a2645ad25aeaef9bcc6f.svg";
export { ForwardRef as ReactComponent };